
// export function getCustomRecoveryList(list_type){
//     return async function (dispatch){ // resume list of selected clients
//         try {
//             dispatch({
//                 type: "GET_CUSTOM_RECOVERY_START"
//             })

//                 const response = await fetch("/recovery/history/all", {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
//                     },
//                     body: JSON.stringify({
//                         list: list_type
//                     }),
//                     credentials: 'same-origin',
//                 });
//                 const res = await response.json();
//                 const list = []
//                 res.content.info.forEach(box => {
//                     // console.log('====================================');
//                     // console.log({box, info: box[i]});
//                     // console.log('====================================');
//                     list.push(box[0])
//                 })
//                 console.log('IN getAlerts ', {res});
            
//             dispatch({
//                 type: "GET_CUSTOM_RECOVERY_LIST",
//                 payload: {list, list_type}
//             })
            
//         } catch (error) {
//             console.log("GET_CUSTOM_RECOVERY", {error});
//             dispatch({
//                 type: "GET_CUSTOM_RECOVERY_ERROR",
//                 payload: error,
//             })
//         }
//     }
// }



export function newRecoveryAction(data, boxAssoId){
    return async function (dispatch){ // resume list of selected clients
        try {
            dispatch({
                type: "CREATE_RECOVERY_ACTION_START"
            })

            const response = await fetch('/recovery/new',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({
                    boxAssoId : boxAssoId,
                    actionList: data
                }),
                credentials: 'same-origin',
            })
            const res = await response.json()
            console.log({res} , res.errorCode);
            
            if (res.errorCode === 200){
                console.log("errorCode = 200");
                // dispatch({
                //     type: "NEW_RECOVERY_ACTION",
                //     payload: {list, list_type}
                // })
                dispatch({
                    type: "CREATE_RECOVERY_ACTION_FULFILLED",
                    payload: "",
                })
            } else {
                console.log({res});
                this.notif("danger", "Un problème est survenu, Veuillez rééssayer")
                dispatch({
                    type: "CREATE_RECOVERY_ACTION_ERROR",
                    payload: res.error.message,
                })
            }

                
            
        } catch (error) {
            console.log("CREATE_ACTION_RECOVERY", {error});
            dispatch({
                type: "CREATE_ACTION_RECOVERY_ERROR",
                payload: error.message,
            })
        }
    }
}
export function getCustomRecoveryList(list_type){
    return async function (dispatch){ // resume list of selected clients
        try {
            dispatch({
                type: "GET_CUSTOM_RECOVERY_START"
            })

                const response = await fetch("/recovery/idList", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body: JSON.stringify({
                        list: list_type
                    }),
                    credentials: 'same-origin',
                });
                const res = await response.json();
                let list = [];

                res.content.info.map(client => {
                    list.push(client[0])
                })
            dispatch({
                type: "GET_CUSTOM_RECOVERY_LIST",
                payload: {list, list_type}
            })
            
        } catch (error) {
            console.log("GET_CUSTOM_RECOVERY", {error});
            dispatch({
                type: "GET_CUSTOM_RECOVERY_ERROR",
                payload: error,
            })
        }
    }
}
